// extracted by mini-css-extract-plugin
module.exports = {"admin":"hera-page-admin_admin___kIGG","admin_title":"hera-page-admin_admin_title__el_uV","admin_text":"hera-page-admin_admin_text__NQTKS"};